import {
  VoiceChannel,
  type VoiceChannelAcceptedOrDeclined,
  VoiceChannelInvite,
} from 'src/provider/VoiceChannel';
import { addListener } from '../common';

export const onVoiceChannelUpdated = addListener<VoiceChannel>('/voice/group');
export const onVoiceChannelListUpdated = addListener<VoiceChannel[]>(
  '/voice/group/active',
);
export const onVoiceChannelRequestUserDisconnect = addListener<VoiceChannel[]>(
  '/voice/user/disconnect',
);

// VOICE INVITE
export const onVoiceChannelInvited = addListener<VoiceChannelInvite>(
  '/voice-channel/invited',
);

export const onVoiceChannelDeclined =
  addListener<VoiceChannelAcceptedOrDeclined>('/voice-channel/declined');

export const onVoiceChannelAccepted =
  addListener<VoiceChannelAcceptedOrDeclined>('/voice-channel/accepted');

// AI
type AILockSocket = {
  ai: string;
  lockedBy: {
    userId: string;
    meetId: string;
  };
};
export const onVoiceChannelAILock = addListener<AILockSocket>('/voice/ai/lock');
export const onVoiceChannelAIUnlock =
  addListener<AILockSocket>('/voice/ai/unlock');
export const onVoiceChannelAIAnswer = addListener('/voice-channel/ai/answer');

export type VoiceControl = {
  sender: string;
  channelId: string;
};
export const onMuteParticipant = addListener<VoiceControl>(
  '/voice-channel/request/mute',
);
export const onKickParticipant = addListener<VoiceControl>(
  '/voice-channel/request/kick',
);

// SoundBoard

export type PlaySoundBoardType = {
  channelId: string;
  requested: string;
  soundId: string;
  volume?: number;
  icon?: string;
};
export const onPlaySound = addListener<PlaySoundBoardType>(
  '/voice-channel/play-soundboard-sound',
);
